import { render } from "./CapsulaInfo.vue?vue&type=template&id=7f3fde49&scoped=true"
import script from "./CapsulaInfo.vue?vue&type=script&lang=js"
export * from "./CapsulaInfo.vue?vue&type=script&lang=js"

import "./CapsulaInfo.vue?vue&type=style&index=0&id=7f3fde49&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f3fde49"]])

export default __exports__